import { MoreHorizontal } from "lucide-react";
import { Button } from "../ui/button";
import {
    DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuSeparator, DropdownMenuTrigger,
} from "../ui/dropdown-menu";

// items: [{ key, label, onSelect, hidden, separatorBefore }]
export function ProjectActionsMenu({ items }) {
    const visible = items.filter((i) => !i.hidden);
    return (
        <DropdownMenu>
            <DropdownMenuTrigger asChild>
                <Button variant="outline" size="icon" data-testid="project-more-menu" aria-label="More actions">
                    <MoreHorizontal size={16} />
                </Button>
            </DropdownMenuTrigger>
            <DropdownMenuContent align="end" className="w-56">
                {visible.map((i) => (
                    <div key={i.key}>
                        {i.separatorBefore && <DropdownMenuSeparator />}
                        <DropdownMenuItem data-testid={`project-menu-${i.key}`} onSelect={i.onSelect}>{i.label}</DropdownMenuItem>
                    </div>
                ))}
            </DropdownMenuContent>
        </DropdownMenu>
    );
}
